import { Link } from "react-router-dom";
import { LegalLayout, LegalSection } from "../components/site/LegalLayout";

export default function MentionsLegales() {
  return (
    <LegalLayout eyebrow="Impressum" title="Mentions légales" updated="28 septembre 2026" testId="mentions-legales-page">
      <LegalSection title="Éditeur du site">
        <dl className="legal-dl">
          <dt>Raison sociale</dt><dd>Stop Cheni</dd>
          <dt>Adresse</dt><dd>Route de Crochy 20, 1024 Écublens, Vaud, Suisse</dd>
          <dt>Téléphone</dt><dd><a href="tel:+41795148245" className="legal-link" data-testid="legal-phone-link">+41 79 514 82 45</a></dd>
          <dt>Email</dt><dd><a href="mailto:info@stopcheni.ch" className="legal-link">info@stopcheni.ch</a></dd>
        </dl>
      </LegalSection>

      <LegalSection title="Hébergement">
        <p>Ce site est hébergé par un prestataire d'hébergement cloud spécialisé. Les serveurs peuvent être situés en Suisse ou à l'étranger (voir notre <Link to="/confidentialite" className="legal-link">politique de confidentialité</Link>).</p>
      </LegalSection>

      <LegalSection title="Propriété intellectuelle">
        <p>L'ensemble des contenus de ce site (textes, images, logos, graphismes, mise en page) est la propriété de Stop Cheni ou fait l'objet d'une autorisation d'utilisation. Toute reproduction, diffusion ou modification, totale ou partielle, sans autorisation écrite préalable est interdite, conformément à la loi fédérale sur le droit d'auteur (LDA).</p>
      </LegalSection>

      <LegalSection title="Limitation de responsabilité">
        <p>Stop Cheni s'efforce de fournir des informations exactes et à jour, sans toutefois pouvoir en garantir l'exactitude, l'exhaustivité ou l'actualité. Les informations publiées sont fournies à titre indicatif et ne constituent pas une offre ferme ; seuls les devis écrits font foi.</p>
        <p>Dans les limites autorisées par la loi, Stop Cheni décline toute responsabilité pour les dommages matériels ou immatériels résultant de l'accès au site, de son utilisation ou de l'impossibilité d'y accéder, ainsi que de l'utilisation des informations qui y sont publiées.</p>
      </LegalSection>

      <LegalSection title="Liens externes">
        <p>Ce site peut contenir des liens vers des sites tiers. Stop Cheni n'exerce aucun contrôle sur ces sites et décline toute responsabilité quant à leur contenu. L'accès à ces sites se fait aux risques de l'utilisateur.</p>
      </LegalSection>

      <LegalSection title="Droit applicable et for">
        <p>Le présent site et les présentes mentions légales sont soumis au droit suisse. Le for juridique est à Lausanne, sous réserve des fors impératifs prévus par la loi.</p>
      </LegalSection>
    </LegalLayout>
  );
}
